import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { handleModal } from 'src/store/actions/modal';
import Header from './Header';
import Container from 'src/components/reusable/Container';
import Modal from 'src/components/reusable/Modal';
import PurchaseSummary from 'src/components/purchase-summary';
import {
  PurchaseError,
  PurchaseSuccess
} from 'src/components/purchase-response';
import { formatPathname } from 'src/utils';

type DashboardLayoutProp = {};

const DashboardLayout = ({}: DashboardLayoutProp) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { open, openPurchaseSummary, openPurchaseSuccess, openPurchaseError } =
    useAppSelector((state) => state.modal);
  const [isMounted, setIsMounted] = useState(false);

  const title = formatPathname(pathname);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  if (!isMounted) {
    return null;
  }

  const handleClose = () => {
    dispatch(handleModal(false));
  };

  return (
    <>
      <Header title={title} />
      <main className="min-h-screen">
        <Container>
          <Outlet />
        </Container>
      </main>
      <Modal
        isAuth
        title={openPurchaseSummary ? 'Purchase Summary' : null}
        isOpen={open}
        closeModal={handleClose}
        icon={
          openPurchaseSummary ? 'bi:arrow-left' : 'clarity:window-close-line'
        }
      >
        {openPurchaseSummary && <PurchaseSummary />}
        {openPurchaseSuccess && <PurchaseSuccess />}
        {openPurchaseError && <PurchaseError />}
      </Modal>
    </>
  );
};

export default DashboardLayout;
